// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Qp5xkmMJGKUSGJdCNCHD {
    padding-top: clamp(1.25rem, 1vw + 1.5rem, 2.5rem);
    padding-bottom: 3rem;
}

.TcLzDOhmWEhsHeTW8l3V {
    max-width: 50rem;
    text-wrap: balance;
    line-height: 150%;
    font-size: clamp(1.5rem, 1vw + 1rem, 2.5rem);
    padding-bottom: clamp(0.875rem, 1vw + 1rem, 2.5rem);
    margin: 0;
    display: flex;
    flex-direction: column;
}

.DoNTXhGlVfwXzS2w7wHR {
    width: 50%;
    aspect-ratio: 1 / 1;
    object-fit: cover;
    border-radius: 1rem;
    filter: grayscale(100%);
}

.TcLzDOhmWEhsHeTW8l3V span:first-child {
    animation: HudWoo857CiUT9LpX9gD 0.5s ease-in-out 0.25s backwards;
}

.TcLzDOhmWEhsHeTW8l3V span:nth-child(2) {
    animation: HudWoo857CiUT9LpX9gD 0.5s ease-in-out 0.5s backwards;
}



@keyframes HudWoo857CiUT9LpX9gD {
    from {
        transform: translateY(1rem);
        opacity: 0;
    }
    to {
        transform: translateY(0);
        opacity: 1;
    }
}

.kif3WEPr7MnUOWCBg2Wo {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    gap: 4rem;
}

.Yv9xio99Cw9TPtIZwuHA {
    width: 60%;
    position: relative;
}

.w8xUymfGFulVLeZ4Nc5g {
    position: absolute;
    width: 16rem;
    top: -11rem;
    right: -5rem;
    z-index: 2;
    animation: ISUIAiCbFgBL2ESyW46p 0.5s ease-in-out 1.25s backwards;
}

.prAqKuapv3XqlhUUK3Vf {
    width: 100%;
    height: 100%;
    aspect-ratio: 16/9;
    animation: HudWoo857CiUT9LpX9gD 0.5s ease-in-out 0.75s backwards;
}

.hpNw69N_2htoQm1W126g {
    position: absolute;
    top: 15rem;
    right: 8rem;
    z-index: 2;
    width: calc(30% - 1rem);
    padding: 2rem;
    border-radius: 1rem;
    background: linear-gradient(135deg, #FFF 0%, rgba(255, 255, 255, 0.56) 100%);
    box-shadow: 0 1px 10px 0 rgba(211, 218, 255, 0.50);
    display: flex;
    flex-direction: column;
    gap: 1rem;
    animation: ISUIAiCbFgBL2ESyW46p 0.5s ease-in-out 1s backwards;
}

.hpNw69N_2htoQm1W126g h2 {
    margin: 0;
    font-size: clamp(0.875rem, 1vw + 0.25rem, 1.5rem);
}

.tE6CwiR4ubEV6pP3jcjA {
    font-size: clamp(0.75rem, 1vw - 0.25rem, 1rem);
}

.RmbKGoaCXQajYKQuNSwU {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 1rem;
}

.RmbKGoaCXQajYKQuNSwU label,
.RmbKGoaCXQajYKQuNSwU input {
    width: 100%;
}

.vLjmm2NEgRuxKqUWnveP label,
.vLjmm2NEgRuxKqUWnveP input {
    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);
}

.vLjmm2NEgRuxKqUWnveP {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.n0RG5kZWtUxZ51nTJ0LS {
    width: 100%;
}

.n0RG5kZWtUxZ51nTJ0LS .kif3WEPr7MnUOWCBg2Wo {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
}

.XJCR_l0P6fCzY9iDz_0z {
    width: 100%;
    height: 0.5rem;
    border-radius: 1rem;
    background: #D3DAFF;
    margin-top: 1rem;
    margin-bottom: 1rem;
}

.PdPrRDEEiTI9iOMPmaQk {
    width: 80%;
    height: 0.5rem;
    background-color: #4F67F3;
    border-radius: 0.5rem;
}

.PdPrRDEEiTI9iOMPmaQk.U9NqHedTZidkMTNuwpM_ {
    width: 16.66%;
}

.bjfh66DBGs10q9xaGDzL {
    color: rgba(0, 0, 0, 0.75);
    font-family: Inter, sans-serif;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: 150%;
}

.l5aFeIEPqDdxwDbQamVy {
    color: rgba(0, 0, 0, 0.50);
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%;
}

._2R_2no4FoxQGTXwNixF {
    display: flex;
    flex-direction: row;
    align-items: center;
}

._2R_2no4FoxQGTXwNixF img:first-child {
    margin-left: 0;
}

._2R_2no4FoxQGTXwNixF img {
    width: 2.5rem;
    height: 2.5rem;
    margin-left: -0.75rem;
}

.k3ds7SKYuwUBf5SXS6Tv {
    width: 2.5rem;
    height: 2.5rem;
    border-radius: 2.5rem;
    border: 2px solid white;
    background-color: #4F67F3;
    display: flex;
    justify-content: center;
    align-items: center;
    color: white;
    font-weight: 500;
    font-size: 0.65rem;
    margin-left: -0.75rem;
    box-sizing: border-box;
}

.XA7gHpg3dVvrmtPudPay {
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 0.75rem;
}

.t4hbJGxfPNTj0OuP_WMS {
    color: rgba(0, 0, 0, 0.50);
    font-family: Inter, sans-serif;
    font-size: 0.75rem;
    font-style: normal;
    font-weight: 400;
    line-height: 150%; /* 0.71963rem */
}

.c6Ew4TrcxtQPr7SaOmnk,
.c6Ew4TrcxtQPr7SaOmnk span {
    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);;
}

.QEvQrEFNeylDkuEtjFdY {
    transition: all 0.3s ease-in-out;
}

.c6Ew4TrcxtQPr7SaOmnk:hover .QEvQrEFNeylDkuEtjFdY,
.pqjGk0haQQE_qeCguSGg:hover .QEvQrEFNeylDkuEtjFdY {
    transform: translateX(0.5rem);
}

@keyframes ISUIAiCbFgBL2ESyW46p {
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
}

.pqjGk0haQQE_qeCguSGg,
.pqjGk0haQQE_qeCguSGg span {
    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem) !important;
}

.IwnpYTox3IX8Sqo_krcQ {
    display: none;
}

@media screen and (max-width: 1024px) {
    .hpNw69N_2htoQm1W126g {
        right: 4rem;
        width: calc(33% - 1rem);
        padding: 1.5rem;
    }
}


@media screen and (max-width: 768px) {
    .w8xUymfGFulVLeZ4Nc5g {
        display: none;
    }

    .HHOM73nTpn9SsD7JBd5G {
        display: none;
    }

    .Yv9xio99Cw9TPtIZwuHA {
        width: 100%;
    }

    .IwnpYTox3IX8Sqo_krcQ {
        display: block;
    }

    .hpNw69N_2htoQm1W126g {
        width: 100%;
        box-sizing: border-box;
        margin-top: 1rem;
    }

    .RmbKGoaCXQajYKQuNSwU {
        flex-wrap: wrap;
    }

    .kif3WEPr7MnUOWCBg2Wo {
        gap: 1rem;
    }

    .kif3WEPr7MnUOWCBg2Wo > div {
        width: 100%;
    }

    .kif3WEPr7MnUOWCBg2Wo > div:nth-child(2) p {
        text-align: right;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/Header/Header.module.css"],"names":[],"mappings":"AAAA;IACI,iDAAiD;IACjD,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,4CAA4C;IAC5C,mDAAmD;IACnD,SAAS;IACT,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,UAAU;IACV,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gEAAqD;AACzD;;AAEA;IACI,+DAAoD;AACxD;;;;AAIA;IACI;QACI,2BAA2B;QAC3B,UAAU;IACd;IACA;QACI,wBAAwB;QACxB,UAAU;IACd;AACJ;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,UAAU;IACV,gEAAmD;AACvD;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,gEAAqD;AACzD;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,UAAU;IACV,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,4EAA4E;IAC5E,kDAAkD;IAClD,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,6DAAgD;AACpD;;AAEA;IACI,SAAS;IACT,iDAAiD;AACrD;;AAEA;IACI,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;AACb;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,UAAU;IACV,cAAc;IACd,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;IACd,qBAAqB;IACrB,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;IACrB,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,0BAA0B;IAC1B,8BAA8B;IAC9B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,iBAAiB,EAAE,eAAe;AACtC;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,gCAAgC;AACpC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;IACI;QACI,UAAU;IACd;IACA;QACI,UAAU;IACd;AACJ;;AAEA;;IAEI,yDAAyD;AAC7D;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI;QACI,WAAW;QACX,uBAAuB;QACvB,eAAe;IACnB;AACJ;;;AAGA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,cAAc;IAClB;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,gBAAgB;IACpB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,SAAS;IACb;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".header {\n    padding-top: clamp(1.25rem, 1vw + 1.5rem, 2.5rem);\n    padding-bottom: 3rem;\n}\n\n.title {\n    max-width: 50rem;\n    text-wrap: balance;\n    line-height: 150%;\n    font-size: clamp(1.5rem, 1vw + 1rem, 2.5rem);\n    padding-bottom: clamp(0.875rem, 1vw + 1rem, 2.5rem);\n    margin: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.picture {\n    width: 50%;\n    aspect-ratio: 1 / 1;\n    object-fit: cover;\n    border-radius: 1rem;\n    filter: grayscale(100%);\n}\n\n.title span:first-child {\n    animation: slideInUp 0.5s ease-in-out 0.25s backwards;\n}\n\n.title span:nth-child(2) {\n    animation: slideInUp 0.5s ease-in-out 0.5s backwards;\n}\n\n\n\n@keyframes slideInUp {\n    from {\n        transform: translateY(1rem);\n        opacity: 0;\n    }\n    to {\n        transform: translateY(0);\n        opacity: 1;\n    }\n}\n\n.row {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: flex-start;\n    gap: 4rem;\n}\n\n.video-wrapper {\n    width: 60%;\n    position: relative;\n}\n\n.arrow {\n    position: absolute;\n    width: 16rem;\n    top: -11rem;\n    right: -5rem;\n    z-index: 2;\n    animation: fade-in 0.5s ease-in-out 1.25s backwards;\n}\n\n.video {\n    width: 100%;\n    height: 100%;\n    aspect-ratio: 16/9;\n    animation: slideInUp 0.5s ease-in-out 0.75s backwards;\n}\n\n.form-container {\n    position: absolute;\n    top: 15rem;\n    right: 8rem;\n    z-index: 2;\n    width: calc(30% - 1rem);\n    padding: 2rem;\n    border-radius: 1rem;\n    background: linear-gradient(135deg, #FFF 0%, rgba(255, 255, 255, 0.56) 100%);\n    box-shadow: 0 1px 10px 0 rgba(211, 218, 255, 0.50);\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    animation: fade-in 0.5s ease-in-out 1s backwards;\n}\n\n.form-container h2 {\n    margin: 0;\n    font-size: clamp(0.875rem, 1vw + 0.25rem, 1.5rem);\n}\n\n.description {\n    font-size: clamp(0.75rem, 1vw - 0.25rem, 1rem);\n}\n\n.form-row {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    gap: 1rem;\n}\n\n.form-row label,\n.form-row input {\n    width: 100%;\n}\n\n.form label,\n.form input {\n    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);\n}\n\n.form {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n}\n\n.wait-list {\n    width: 100%;\n}\n\n.wait-list .row {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.progress-bar {\n    width: 100%;\n    height: 0.5rem;\n    border-radius: 1rem;\n    background: #D3DAFF;\n    margin-top: 1rem;\n    margin-bottom: 1rem;\n}\n\n.progress {\n    width: 80%;\n    height: 0.5rem;\n    background-color: #4F67F3;\n    border-radius: 0.5rem;\n}\n\n.progress.other {\n    width: 16.66%;\n}\n\n.label {\n    color: rgba(0, 0, 0, 0.75);\n    font-family: Inter, sans-serif;\n    font-size: 1rem;\n    font-style: normal;\n    font-weight: 700;\n    line-height: 150%;\n}\n\n.hint {\n    color: rgba(0, 0, 0, 0.50);\n    font-family: Inter, sans-serif;\n    font-size: 0.75rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%;\n}\n\n.investors {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n}\n\n.investors img:first-child {\n    margin-left: 0;\n}\n\n.investors img {\n    width: 2.5rem;\n    height: 2.5rem;\n    margin-left: -0.75rem;\n}\n\n.other-invest {\n    width: 2.5rem;\n    height: 2.5rem;\n    border-radius: 2.5rem;\n    border: 2px solid white;\n    background-color: #4F67F3;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: white;\n    font-weight: 500;\n    font-size: 0.65rem;\n    margin-left: -0.75rem;\n    box-sizing: border-box;\n}\n\n.investors-container {\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 0.75rem;\n}\n\n.wait-list-number {\n    color: rgba(0, 0, 0, 0.50);\n    font-family: Inter, sans-serif;\n    font-size: 0.75rem;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 150%; /* 0.71963rem */\n}\n\n.submit,\n.submit span {\n    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem);;\n}\n\n.arrow-icon {\n    transition: all 0.3s ease-in-out;\n}\n\n.submit:hover .arrow-icon,\n.link:hover .arrow-icon {\n    transform: translateX(0.5rem);\n}\n\n@keyframes fade-in {\n    from {\n        opacity: 0;\n    }\n    to {\n        opacity: 1;\n    }\n}\n\n.link,\n.link span {\n    font-size: clamp(0.80rem, 1vw - 0.25rem, 1rem) !important;\n}\n\n.mobile {\n    display: none;\n}\n\n@media screen and (max-width: 1024px) {\n    .form-container {\n        right: 4rem;\n        width: calc(33% - 1rem);\n        padding: 1.5rem;\n    }\n}\n\n\n@media screen and (max-width: 768px) {\n    .arrow {\n        display: none;\n    }\n\n    .desktop {\n        display: none;\n    }\n\n    .video-wrapper {\n        width: 100%;\n    }\n\n    .mobile {\n        display: block;\n    }\n\n    .form-container {\n        width: 100%;\n        box-sizing: border-box;\n        margin-top: 1rem;\n    }\n\n    .form-row {\n        flex-wrap: wrap;\n    }\n\n    .row {\n        gap: 1rem;\n    }\n\n    .row > div {\n        width: 100%;\n    }\n\n    .row > div:nth-child(2) p {\n        text-align: right;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Qp5xkmMJGKUSGJdCNCHD`,
	"title": `TcLzDOhmWEhsHeTW8l3V`,
	"picture": `DoNTXhGlVfwXzS2w7wHR`,
	"slideInUp": `HudWoo857CiUT9LpX9gD`,
	"row": `kif3WEPr7MnUOWCBg2Wo`,
	"video-wrapper": `Yv9xio99Cw9TPtIZwuHA`,
	"arrow": `w8xUymfGFulVLeZ4Nc5g`,
	"fade-in": `ISUIAiCbFgBL2ESyW46p`,
	"video": `prAqKuapv3XqlhUUK3Vf`,
	"form-container": `hpNw69N_2htoQm1W126g`,
	"description": `tE6CwiR4ubEV6pP3jcjA`,
	"form-row": `RmbKGoaCXQajYKQuNSwU`,
	"form": `vLjmm2NEgRuxKqUWnveP`,
	"wait-list": `n0RG5kZWtUxZ51nTJ0LS`,
	"progress-bar": `XJCR_l0P6fCzY9iDz_0z`,
	"progress": `PdPrRDEEiTI9iOMPmaQk`,
	"other": `U9NqHedTZidkMTNuwpM_`,
	"label": `bjfh66DBGs10q9xaGDzL`,
	"hint": `l5aFeIEPqDdxwDbQamVy`,
	"investors": `_2R_2no4FoxQGTXwNixF`,
	"other-invest": `k3ds7SKYuwUBf5SXS6Tv`,
	"investors-container": `XA7gHpg3dVvrmtPudPay`,
	"wait-list-number": `t4hbJGxfPNTj0OuP_WMS`,
	"submit": `c6Ew4TrcxtQPr7SaOmnk`,
	"arrow-icon": `QEvQrEFNeylDkuEtjFdY`,
	"link": `pqjGk0haQQE_qeCguSGg`,
	"mobile": `IwnpYTox3IX8Sqo_krcQ`,
	"desktop": `HHOM73nTpn9SsD7JBd5G`
};
export default ___CSS_LOADER_EXPORT___;
